module.exports = __webpack_public_path__ + "static/media/visit_4.84efed6c.jpg";